import { PushMessageType } from '@core/models/user/enums';
import {
    isBrazil,
    isPoland,
    isRomania,
} from '@modules/layout/utils/isCountry';
import { MessageDto } from './dtos/MessageDto';

export function getMessageTypeMapper() {
    const isComtradeNotification = isPoland() || isRomania();
    const brazilMigrationVersionRegex = /\d+\.\d+\.99+/; // x.x.99+

    function isComtradeTermsUpdate(obj: MessageDto): boolean {
        // Per Comtrade's specs, this is the given way to identify a terms update message
        return obj.Message.GroupId === -1 && obj.Message.ReferenceObjectId === '0';
    }

    return (obj: MessageDto): PushMessageType | undefined => {
        if (isComtradeNotification && isComtradeTermsUpdate(obj)) {
            return PushMessageType.TermsUpdate;
        } else if (isBrazil() && obj.Message.Data?.version && brazilMigrationVersionRegex.test(obj.Message.Data.version)) {
            return PushMessageType.BrazilMigrationTerms;
        } else {
            return obj.Message.MessageType;
        }
    };
}
